import React, { useContext, useEffect, useState } from "react";
import {DropDown} from "../../components/DropDown";
import {FormGroup} from "../../components/FormGroup";
import { HexpertContext } from "../../contexts/HexPertProvider";
import { PageQuestion, PageQuestionOption } from "../../types/hexpertTypes";

type WeFitDropDownBlockProps = PageQuestion & {
  action?: () => void;
};

export const WeFitDropDownBlock = ({
  Label,
  Options,
  FieldId,
}: WeFitDropDownBlockProps) => {
  // @TODO
  const [select, setSelected] = useState<string>(null);
  const [items, setItems] = useState<PageQuestionOption[]>(null);
  const { state, dispatch } = useContext(HexpertContext);
  useEffect(() => {
    const relatedOptions = Options?.filter((option) => {
      return option.ValueRelevantTo?.split(",").some(
        (value) => value === state.chosenIndustry?.Value
      );
    });
    if (
      state?.chosenIndustry &&
      !state?.formAnswers?.[FieldId] &&
      relatedOptions?.find((item) => item.Checked) &&
      state?.showLastQuestions
    ) {
      // assuming this is the last steps
      dispatch({
        type: "setAnswer",
        payload: {
          [FieldId]: relatedOptions
            ?.find((item) => item.Checked)
            ?.Value?.toString(),
        },
      });
    }
    setItems(relatedOptions);
  }, [state.chosenIndustry?.Value, Options, state?.showLastQuestions]);

  return items ? (
    <FormGroup title={Label}>
      {items?.length > 0 && (
        <DropDown
          name="dropdown"
          options={items}
          onChange={(val) =>
            dispatch({ type: "setAnswer", payload: { [FieldId]: val } })
          }
          selected={
            state?.formAnswers && state?.formAnswers[FieldId]
              ? state?.formAnswers[FieldId]
              : items?.find((item) => item.Checked)
              ? items?.find((item) => item.Checked)?.Value
              : null
          }
          defaultValue={"Select"}
        />
      )}
    </FormGroup>
  ) : null;
};
